import business from "./business";

// schema.org MedicalClinic (a LocalBusiness subtype) with full NAP - used
// on the homepage as the primary entity for the whole site.
export function buildLocalBusinessSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "@id": `${business.siteUrl}/#organization`,
    name: business.name,
    alternateName: business.legalName,
    description: business.description,
    url: business.siteUrl,
    logo: business.logo,
    image: business.logo,
    telephone: business.telephone,
    email: business.email,
    medicalSpecialty: "Addiction Medicine",
    address: {
      "@type": "PostalAddress",
      ...business.address,
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: business.geo.latitude,
      longitude: business.geo.longitude,
    },
    openingHoursSpecification: business.openingHours.map((spec) => ({
      "@type": "OpeningHoursSpecification",
      dayOfWeek: spec.dayOfWeek,
      opens: spec.opens,
      closes: spec.closes,
    })),
  };
}

// schema.org BreadcrumbList matching the visible "Home / X" breadcrumb
// already shown in each page's hero banner.
export function buildBreadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${business.siteUrl}${item.path}`,
    })),
  };
}

export function buildWebsiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: business.name,
    url: business.siteUrl,
  };
}
